import { render, staticRenderFns } from "./UnionPayQRAMerchant.vue?vue&type=template&id=3aa35c7f&scoped=true&"
import script from "./UnionPayQRAMerchant.vue?vue&type=script&lang=js&"
export * from "./UnionPayQRAMerchant.vue?vue&type=script&lang=js&"
import style0 from "./UnionPayQRAMerchant.vue?vue&type=style&index=0&id=3aa35c7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aa35c7f",
  null
  
)

export default component.exports